import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
// import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  AddQuicktalesToOrgTableHeadCells,
  getComparator,
  stableSort,
  routes,
} from "../../../../constants";

import TablePaginationSection from "../../../../common/TablePaginationSection";
import ImagePreviewModal from "../../../../common/ImagePreviewModal";
import AudioModal from "../../../../common/AudioModal";
import { AddQuickTalesToOrgTableRow } from "../components";
import { useQuickTalesContext } from "../../../../providers/OrganizationAdmin/QuickTalesProvider";
import CommonTableHead from "../../../../common/CommonTableHead";

export default function AddQuickTalesToOrgTable({
  selected,
  setSelected,
  quictalesInOrg,
}) {
  const {
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
  } = useQuickTalesContext();
  const navigate = useNavigate();
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [audioModal, setAudioModal] = useState(false);
  const [selectedAudioFile, setSelectedAudioFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("approvalStatus.updatedAt");

  // Initialize column widths based on AddQuicktalesToOrgTableHeadCells
  const initializeColumnWidths = () => {
    const widths = {};
    AddQuicktalesToOrgTableHeadCells.forEach(cell => {
      widths[cell.id] = cell.width || 150;
    });
    return widths;
  };

  const [columnWidths, setColumnWidths] = useState(initializeColumnWidths);

  const handleColumnResize = (columnId, newWidth) => {
    setColumnWidths(prev => ({
      ...prev,
      [columnId]: newWidth
    }));
  };

  const handleImagePreviewModalOpen = () => {
    setImagePreviewModal(true);
  };
  const handleImagePreviewModalClose = () => {
    setImagePreviewModal(false);
    setSelectedImage(null);
  };

  const handleAudioModalOpen = () => {
    setAudioModal(true);
  };
  const handleAudioModalClose = () => {
    setAudioModal(false);
    setSelectedAudioFile(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page - 1 > 0
      ? Math.max(0, (1 + page - 1) * rowsPerPage - quictalesInOrg.length)
      : 0;

  const visibleRows = useMemo(
    () =>
      stableSort(quictalesInOrg, getComparator(order, orderBy)).slice(
        (page - 1) * rowsPerPage,
        (page - 1) * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, quictalesInOrg]
  );

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = visibleRows.map((n) => n.id);
      // const newSelected = quictalesInOrg.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClickRow = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    console.log(newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  // console.log(Math.ceil(2.1))

  return (
    <Box sx={mainBoxContainerStyles}>
      {/* <Scrollbars
        style={scrollbar}
        autoHide={true}
        ref={scrollbarsRef} 
        renderThumbVertical={({ style, ...props }) => (
          <div
            {...props}
            style={{
              ...style,
              ...scrollbarprops,
            }}
          />
        )}
      > */}
      <Paper sx={tablePaperContainerStyles}>
        <TableContainer
          style={{ border: "none", boxShadow: "none", maxHeight: "calc(90vh - 220px)", maxWidth: "calc(90vw - 120px)" }}
        >
          <Table
            stickyHeader
            aria-labelledby="tableTitle"
          >
            <CommonTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={visibleRows.length}
              tableHeadCells={AddQuicktalesToOrgTableHeadCells}
              columnWidths={columnWidths}
              onColumnResize={handleColumnResize}
            />
            {/* <AddQuickTalesToOrgTableHead
      >
        <Paper sx={tablePaperContainerStyles}>
          <TableContainer style={{ border: "none", boxShadow: "none" }}>
            <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
              <TableHeadComponent
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                // rowCount={quictalesInOrg.length}
                rowCount={visibleRows.length}
              /> */}
         
              <TableBody>
                {visibleRows.map((row, index) => {
                  const isItemSelected = isSelected(row.id);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  const numberType = index % 2 == 0;

                return (
                  <AddQuickTalesToOrgTableRow
                    isItemSelected={isItemSelected}
                    row={row}
                    handleClickRow={handleClickRow}
                    numberType={numberType}
                    labelId={labelId}
                    key={index}
                    columnWidths={columnWidths}
                    handleImagePreviewModalOpen={handleImagePreviewModalOpen}
                    handleAudioModalOpen={handleAudioModalOpen}
                    setSelectedAudioFile={setSelectedAudioFile}
                    setSelectedImage={setSelectedImage}
                    handleNavigateToDetails={() => {
                      navigate(routes.addQuicktalesToOrgDetails, {
                        state: { quicktaleDetails: row },
                      });
                    }}
                  />
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
               {visibleRows.length === 0 && (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No results found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {/* </Scrollbars> */}
      <TablePaginationSection
        count={Math.ceil(quictalesInOrg.length / rowsPerPage)}
        page={page}
        total={quictalesInOrg.length ?? 0}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <ImagePreviewModal
        modalOpen={imagePreviewModal}
        handleClose={handleImagePreviewModalClose}
        image={selectedImage && selectedImage}
        // image={images.tableDummyImage}
      />
      <AudioModal
        modalOpen={audioModal}
        handleClose={handleAudioModalClose}
        audioFile={selectedAudioFile && selectedAudioFile}
        // audioFile={audios.audioSample}
      />
    </Box>
  );
}

const mainBoxContainerStyles = {
  width: "100%",
  paddingRight: 1,
  border: "none",
  boxShadow: "none",
  // marginTop: 2,
};

const tablePaperContainerStyles = {
  maxWidth: "100%",
  mb: 1,
  border: "none",
  boxShadow: "none",
  mt: 1,
};

const scrollbar = { maxWidth: "100%", height: "500px", marginLeft: "auto" };
// const scrollbar = { width: "100%", height: "500px", marginLeft: "auto" };
const scrollbarprops = {
  width: "4px",
  backgroundColor: "#00A7CD",
  borderRadius: "2px",
};
